import { union } from 'io-ts/Decoder';

import { Request as DefiniteRequest } from './definite/Request';
import { Request as DisabledRequest } from './disabled/Request';
import { Request as IndefiniteRequest } from './indefinite/Request';

export const Request = union(DisabledRequest, DefiniteRequest, IndefiniteRequest);
